
import {
  createJobTicket,
  deleteJobAttachment,
  editJobTicket,
  getDetailedJob,
  getDetailedJobById,
  getJobArticles,
  getJobTicket,
  getReferencesParams,
  uploadJobFiles,
  getZammadChannelsEmail,
  getJobTicketsByJobIdShort,
  getDetailedAirRoadJobByRHId,
} from '@/api';
import store from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { isCancel } from 'axios';
import { sendError } from '@/helpers/sentry';
import Avatar from '@/components/UI/Avatar.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import Icon from '@/components/UI/Icon.vue';
import Header from '@/components/jobDetailed/Header/Header.vue';
import Messages from '@/components/jobDetailed/Messages/Messages.vue';
import Note from '@/components/jobDetailed/Note/Note.vue';
import POD from '@/components/jobDetailed/POD/POD.vue';
import Products from '@/components/jobDetailed/Products/Products.vue';
import Stop from '@/components/jobDetailed/Stop/Stop.vue';
import UploadAttachments from '@/components/UI/UploadAttachments/UploadAttachments.vue';

import ZammadList from '@/components/jobDetailed/ZammadList.vue';
import ZammadTicket from '@/components/jobDetailed/ZammadTicket.vue';
import ZammadTicketCreationForm from '@/components/jobDetailed/ZammadTicketCreationForm.vue';
import AirRoadJobsDetailed from '@/components/jobDetailed/AirRoad/AirRoadJobsDetailed.vue';
import JobDetailedImages from '@/components/jobDetailed/JobImages/JobDetailedImages.vue';

import { format, utcToZonedTime } from 'date-fns-tz';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { components } from '@/models/jobDetailed';
type DetailedJob = components['schemas']['Job'];

import { ReferencesParams, User } from '@/models/main';

import { JobTicket, JobTicketAtricle, JobTicketResponce, ZammadTicketData } from '@/models/jobTicket';
import { notificationErrorText } from '@/utils/PortalConstants';
import { checkTicketIsRfc, cleanEmailString, generateUserEmailName, parseSpecialInstructions } from '@/utils/Common';
import { generateEmailSignature } from '@/helpers/zammadEmailTemplates';
import * as routeNames from '@/router/routeNames';

import * as Sentry from '@sentry/vue';
import { AirroadJobDetailed } from '@/models/airRoad';
import { fetchReferencesParams } from '@/helpers/fetchers';

@Component({
  components: {
    Avatar,
    DateTimezoneToggle,
    Header,
    Icon,
    Messages,
    Note,
    Stop,
    StopDrawing,
    POD,
    Products,
    UploadAttachments,
    AirRoadJobsDetailed,
    ZammadList,
    ZammadTicket,
    ZammadTicketCreationForm,
    JobDetailedImages,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class JobDetailed extends Vue {
  public jobId = -1;
  private jobDate = '';

  public format = format;
  public utcToZonedTime = utcToZonedTime;
  public checkTicketIsRfc = checkTicketIsRfc;
  public parseSpecialInstructions = parseSpecialInstructions;

  public job: DetailedJob;
  public files: File[] = [];

  public loading = false;
  public loadingTickets = false;
  public loadingTicketArticles = false;
  public loadingRfcRequest = false;
  public timeZoneDefault = timeZoneDefault;
  public arJobs: AirroadJobDetailed[] = [];

  public newRequestForChangeDialogOpen = false;
  public newMailOpen = false;
  public newMailOpenToTop = false;
  public opsEmails: string[] = [];
  private channelsEmailList: string[] = [];

  public user: User;

  public zammadFormData: ZammadTicketData = {
    toChips: [],
    ccChips: [],
    subject: '',
    msg: '',
    is_rfc: false,
  };

  // Mail data
  // Tickets
  public ticketsData: JobTicketResponce[] = [];

  public editingTicketIdx = -1;
  public editingTicketArticles: JobTicketAtricle[] = [];
  public editingTicketData: JobTicketResponce = {
    article_count: 0,
    article_ids: [],
    close_at: '',
    close_diff_in_min: null,
    close_escalation_at: null,
    close_in_min: null,
    create_article_sender: '',
    create_article_sender_id: 0,
    create_article_type: '',
    create_article_type_id: 0,
    created_at: '',
    created_by: '',
    created_by_id: 0,
    customer: '',
    customer_id: 0,
    escalation_at: null,
    first_response_at: '',
    first_response_diff_in_min: 0,
    first_response_escalation_at: null,
    first_response_in_min: '',
    group: '',
    group_id: 0,
    id: 0,
    last_contact_agent_at: '',
    last_contact_at: '',
    last_contact_customer_at: '',
    last_owner_update_at: null,
    note: null,
    number: '',
    organization_id: null,
    owner: '',
    owner_id: 0,
    pending_time: null,
    preferences: {
      escalation_calculation: {
        calendar_id: 0,
        calendar_updated_at: '',
        escalation_disabled: false,
        first_response_at: '',
        last_contact_at: '',
        last_update_at: '',
        sla_id: 0,
        sla_updated_at: '',
      },
    },
    calendar_id: 0,
    calendar_updated_at: '',
    escalation_disabled: false,
    last_update_at: '',
    sla_id: 0,
    sla_updated_at: '',
    priority: '',
    priority_id: 0,
    rh_job: '',
    state: '',
    state_id: 0,
    ticket_time_accounting: [],
    ticket_time_accounting_ids: [],
    time_unit: null,
    title: '',
    type: null,
    update_diff_in_min: null,
    update_escalation_at: null,
    update_in_min: null,
    updated_at: '',
    updated_by: '',
    updated_by_id: 0,
    is_rfc: false,
  };

  public dialogEditTicket = false;

  public jobIdClicked(id) {
    if (Number(id) !== this.job.rockhopper_id) {
      this.$router.push({ path: '/job/' + id });
    }
  }

  public async setTicketState(state: string, state_id: number) {
    this.loadingRfcRequest = true;
    const newTicketData: JobTicketResponce = {
      ...this.editingTicketData,
      state: state,
      state_id: state_id,
    };
    await editJobTicket(newTicketData)
      .then(() => {
        this.ticketsData[this.editingTicketIdx].state = 'Closed';
        this.ticketsData[this.editingTicketIdx].state_id = 4;
        this.editingTicketData.state = 'Closed';
        this.editingTicketData.state_id = 4;
        this.$notify({
          group: 'network',
          text: 'Ticket successfully closed',
          type: 'success',
          duration: 3000,
        });
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error closing the ticket',
          text: notificationErrorText,
          type: 'warn',
        });
      });
    this.loadingRfcRequest = false;
  }

  public zammadListChanged(ticket) {
    const ticketIdx = this.ticketsData.findIndex(x => Number(x.id) === ticket.id);
    if (ticketIdx >= 0) {
      this.ticketsData[ticketIdx] = { ...ticket };
      this.ticketsData[ticketIdx].state = ticket.state;
      this.ticketsData[ticketIdx].state_id = ticket.state_id;
      this.editingTicketData.state = ticket.state;
      this.editingTicketData.state_id = ticket.state_id;
    }
  }

  public async ticketFormSubmitted(formData: {
    msg: string;
    subject: string;
    is_rfc: boolean;
    toChips: string[];
    ccChips: string[];
    attachments: File[];
  }) {
    this.loadingRfcRequest = true;
    const params: ReferencesParams = await fetchReferencesParams(this.job.customer);
    const companyName = params?.name || this.user.customer;
    const group = process.env.VUE_APP_SENTRY_ENVIRONMENT === 'production' ? 'Service Delivery Team' : 'IT Support';

    const bodyRfc = `
    <div>
      <h3>A new request for change of the Job ${companyName}, 
      #<a href='https://portal.kkts.com.au/job/${this.job.rockhopper_id}'>${this.job.rockhopper_id}</a>, 
      ref: ${this.job.reference_1}</h3><br/>
      <div>${formData.msg}</div>
    </div>`;

    const bodyNote = `
    <div>
      <h3>Job ${companyName}, 
      #<a href='https://portal.kkts.com.au/job/${this.job.rockhopper_id}'>${this.job.rockhopper_id}</a>, 
      ref: ${this.job.reference_1}</h3><br/>
      <div>${formData.msg}</div>
    </div>`;

    let body = formData.is_rfc ? bodyRfc : bodyNote;

    if (this.$ability.can('staff', 'Job')) {
      const signature = generateEmailSignature({
        fullName: generateUserEmailName(this.user),
        email: this.user.email || 'info@kkts.com.au',
        phone: this.user.phone_number || '(02) 9575-0000',
        group: group,
      });
      body += '<br/><br/>' + signature;
    }

    const ticketData: JobTicket = {
      title: formData.subject,
      group: group,
      customer: store.getters['moduleUser/user'].email.toLowerCase(),
      article: {
        subject: formData.is_rfc ? `[RFC] ${formData.subject}` : formData.subject,
        body: body,
        type: this.$ability.can('staff', 'Job') && !formData.is_rfc ? 'email' : 'note',
        content_type: 'text/html',
        sender: this.$ability.can('staff', 'Job') ? 'Agent' : 'Customer',
        internal: false,
        attachments: formData.attachments,
        ...(!formData.is_rfc && this.$ability.can('staff', 'Job')
          ? { to: cleanEmailString(formData.toChips, this.channelsEmailList).join(', ') }
          : {}),
        ...(!formData.is_rfc && this.$ability.can('staff', 'Job')
          ? { cc: cleanEmailString(formData.ccChips, this.channelsEmailList).join(', ') }
          : {}),
      },
      rh_job: this.jobId,
      is_rfc: formData.is_rfc,
    };
    //
    createJobTicket(ticketData)
      .then(() => {
        this.newRequestForChangeDialogOpen = false;
        this.newMailOpen = false;
        this.zammadFormData.toChips = [];
        this.zammadFormData.subject = '';
        this.zammadFormData.msg = '';
        this.zammadFormData.ccChips = this.opsEmails;
        this.$notify({
          group: 'network',
          text: 'The ticket was successfully created',
          type: 'success',
          duration: 3000,
        });
        this.loading = true;
        setTimeout(() => {
          this.fetchData();
        }, 5000);
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'An error occurred when creating the ticket',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.loadingRfcRequest = false;
      });
  }

  private setModalOpenDirection(): void {
    const el = document.querySelector('[attr-scroll-id="newRequest"]');
    if (el) {
      const distFromElToViewportBottom = el.getBoundingClientRect().top + el.getBoundingClientRect().height + 300;
      if (window.innerHeight - distFromElToViewportBottom < 0) {
        this.newMailOpenToTop = true;
      } else {
        this.newMailOpenToTop = false;
      }
    }
  }

  public newTicketClicked(): void {
    this.newRequestForChangeDialogOpen = !this.newRequestForChangeDialogOpen;
    this.setModalOpenDirection();
  }

  public newMailClicked(): void {
    this.newMailOpen = !this.newMailOpen;
    this.setModalOpenDirection();
  }

  public newRequestForChangeDialogClickedOutside(): void {
    this.newRequestForChangeDialogOpen = false;
  }

  public newMailClickedOutside(): void {
    this.newMailOpen = false;
  }

  public ticketDialogCloseClicked(): void {
    this.dialogEditTicket = false;
  }

  // Ticket title click
  public zammadArticleClicked(ticket: { id: number }): void {
    this.ticketClicked(ticket.id);
  }

  public async ticketClicked(id: number): Promise<void> {
    this.dialogEditTicket = true;
    this.loadingTicketArticles = true;
    this.editingTicketIdx = this.ticketsData.findIndex(x => x.id === id);
    // Get ticket
    await getJobTicket(id)
      .then(res => {
        this.editingTicketData = res;
      })
      .catch(() => {
        this.ticketDialogCloseClicked();
        this.$notify({
          group: 'network',
          title: 'Error getting the ticket',
          text: notificationErrorText,
          type: 'warn',
        });
      });
    // Get articles
    await getJobArticles(id)
      .then(res => {
        this.editingTicketArticles = res;
      })
      .catch(() => {
        this.ticketDialogCloseClicked();
        this.$notify({
          group: 'network',
          title: 'Error getting the ticket',
          text: notificationErrorText,
          type: 'warn',
        });
      });
    this.loadingTicketArticles = false;
  }

  public deleteAttachment(id: number): void {
    deleteJobAttachment(id)
      .then(() => {
        const filteredAttachments = this.job.attachments?.filter(x => x.id !== id);
        this.job.attachments = filteredAttachments;
        this.$forceUpdate();
        this.$notify({
          group: 'network',
          text: 'File successfully deleted',
          type: 'success',
          duration: 3000,
        });
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error deleting the job',
          text: notificationErrorText,
          type: 'warn',
        });
      });
  }

  public handleImageDeleted(data: { stopIdx: number; imageIdx: number }): void {
    if (this.job.stops && this.job.stops[data.stopIdx]) {
      const stop = this.job.stops[data.stopIdx];
      if (stop.app_images) {
        stop.app_images.splice(data.imageIdx, 1);
      }
    }
    this.$forceUpdate();
  }

  private async getOpsEmails(): Promise<void> {
    await getReferencesParams(this.job.customer)
      .then(res => {
        this.opsEmails = res.ops_emails;
        this.zammadFormData.ccChips = this.opsEmails;
      })
      .catch(err => {
        sendError(err, 'JobDetailed-getOpsEmails');
      });
  }

  private async getZammadChannelsEmailWrapper() {
    await getZammadChannelsEmail()
      .then(res => {
        this.channelsEmailList = res;
      })
      .catch(err => {
        sendError(err, 'JobDetailed-getZammadChannels');
      });
  }

  private async getJobTickets() {
    await getJobTicketsByJobIdShort(this.jobId, this.jobDate)
      .then(res => {
        // Mail tickets:
        this.ticketsData = res;
      })
      .catch(err => {
        sendError(err, 'JobDetailed-getTicketByJobShort');
      });
  }

  private async getAirRoadJobsData(rh_id: number, rh_date: string) {
    getDetailedAirRoadJobByRHId(rh_id, rh_date)
      .then((data: AirroadJobDetailed[]) => {
        this.arJobs = data;
      })
      .catch(err => {
        this.$notify({
          group: 'network',
          title: 'Error getting AirRoad detailed data',
          text: notificationErrorText,
          type: 'warn',
        });
        Sentry.withScope(scope => {
          scope.setLevel('error');
          Sentry.captureException(err);
        });
      });
  }

  public fetchData(withoutLoaders?: boolean, job_date?: string): void {
    if (job_date) {
      this.jobDate = job_date;
      this.$router.replace({
        name: routeNames.DETAILED_QUERY_JOB,
        query: { job_id: String(this.jobId), job_date: job_date },
      });
    }
    if (!withoutLoaders) {
      this.loading = true;
    }
    getDetailedJob(this.jobId, this.jobDate)
      .then(async (data: DetailedJob) => {
        this.job = data;
        await this.getOpsEmails();
        await this.getZammadChannelsEmailWrapper();
        await this.getJobTickets();
        await this.getAirRoadJobsData(data.rockhopper_id, data.rockhopper_date);
      })
      .catch(err => {
        if (!isCancel(err)) {
          sendError(err, 'JobDetailed');
          if (err.response.status !== 401) {
            this.$router.replace({ path: '/error' });
          }
        }
      })
      .finally(() => {
        if (!withoutLoaders) {
          this.loading = false;
        }
      });
  }

  private fetchDataById(id: number): void {
    this.loading = true;
    getDetailedJobById(id)
      .then(async (data: DetailedJob) => {
        this.job = data;
        await this.getOpsEmails();
        await this.getZammadChannelsEmailWrapper();
        // Set job id & date:
        this.jobId = id;
        this.jobDate = data.rockhopper_date;
        await this.getJobTickets();
        await this.getAirRoadJobsData(this.jobId, this.jobDate);
      })
      .catch(err => {
        if (!isCancel(err)) {
          sendError(err, 'JobDetailed');
          if (err.response.status !== 401) {
            this.$router.replace({ path: '/error' });
          }
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // FOR UPDATING MESSAGES
  public fetchDataNoLoader(): void {
    getDetailedJob(this.jobId, this.jobDate)
      .then((data: DetailedJob) => {
        this.job = data;
        this.$forceUpdate();
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error updating the job',
          text: notificationErrorText,
          type: 'warn',
        });
      });
  }

  public changeFiles(files: File[]): void {
    this.files = files;
    if (this.files.length > 0) {
      const params = {
        rh_id: Number(this.job.rockhopper_id),
        rh_date: String(this.job.rockhopper_date),
        files: this.files,
      };
      uploadJobFiles(params)
        .then(res => {
          if (res?.data?.saved.length > 0) {
            res?.data?.saved.map((item: { file: any; id: any }) => {
              this.job.attachments?.push({
                created_at: '',
                file: item.file,
                id: item.id,
                uploaded_by: '',
              });
            });
            this.$forceUpdate();
            this.$notify({
              group: 'network',
              text: 'File(s) successfully uploaded',
              type: 'success',
              duration: 3000,
            });
          }
        })
        .catch(() => {
          this.$notify({
            group: 'network',
            text: 'Attachments upload failed',
            type: 'warn',
          });
        });
    }
  }

  private created() {
    // Set job Id & date for old route
    if (this.$route.query.job_id) {
      this.jobId = Number(this.$route.query.job_id);
    }
    if (this.$route.query.job_date) {
      this.jobDate = String(this.$route.query.job_date);
    }
    // For Id in the URL
    if (this.$route.params.id) {
      // New route: `/job/:id/`
      this.fetchDataById(Number(this.$route.params.id));
    } else if (!this.jobId && !this.jobDate) {
      this.$router.push({ path: '/dash' });
    } else {
      // Old route: `/detailed-job?job_id=${id}&job_date=${date}`
      this.fetchData();
    }
    // Route changes watcher:
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        if (toParams.id && previousParams.id) {
          this.fetchDataById(Number(this.$route.params.id));
        }
      },
    );
  }

  private mounted() {
    store.dispatch('setRouterData', {
      name: this.$route.name,
      url: this.$route.fullPath,
    });
  }
}
